import HighlightsSection from './HighlightsSection.component';

export default HighlightsSection;
